import { render, staticRenderFns } from "./mtext-terms.vue?vue&type=template&id=95a5e682&"
import script from "./mtext-terms.vue?vue&type=script&lang=js&"
export * from "./mtext-terms.vue?vue&type=script&lang=js&"
import style0 from "./mtext-terms.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports